/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditNoteSummary } from './CreditNoteSummary';
import {
    CreditNoteSummaryFromJSON,
    CreditNoteSummaryFromJSONTyped,
    CreditNoteSummaryToJSON,
    CreditNoteSummaryToJSONTyped,
} from './CreditNoteSummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultCreditNoteSummary
 */
export interface PagedAndSyncedResultCreditNoteSummary {
    /**
     * 
     * @type {Array<CreditNoteSummary>}
     * @memberof PagedAndSyncedResultCreditNoteSummary
     */
    content: Array<CreditNoteSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultCreditNoteSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultCreditNoteSummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultCreditNoteSummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultCreditNoteSummary interface.
 */
export function instanceOfPagedAndSyncedResultCreditNoteSummary(value: object): value is PagedAndSyncedResultCreditNoteSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultCreditNoteSummaryFromJSON(json: any): PagedAndSyncedResultCreditNoteSummary {
    return PagedAndSyncedResultCreditNoteSummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultCreditNoteSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultCreditNoteSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(CreditNoteSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultCreditNoteSummaryToJSON(json: any): PagedAndSyncedResultCreditNoteSummary {
    return PagedAndSyncedResultCreditNoteSummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultCreditNoteSummaryToJSONTyped(value?: PagedAndSyncedResultCreditNoteSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(CreditNoteSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

